var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 100,
    height: 100,
    rx: 30,
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5859 26.5C32.7902 26.5 27.2812 32.009 27.2812 38.8047V88.0234C27.2812 94.8191 32.7902 100.328 39.5859 100.328H88.8047C95.6004 100.328 101.109 94.8191 101.109 88.0234V38.8047C101.109 32.009 95.6004 26.5 88.8047 26.5H39.5859ZM43.2525 42.3203H57.2053L67.1135 56.4L79.1367 42.3203H83.5312L69.098 59.2188L86.8959 84.5078H72.9467L61.4488 68.1725L47.4961 84.5078H43.1016L59.4643 65.3539L43.2525 42.3203ZM49.9818 45.8359L74.7799 80.9922H80.1666L55.3686 45.8359H49.9818Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2e2f8498af1d108fc3d12aa741dc4170.svg";
export { ForwardRef as ReactComponent };